module.exports = {
      id: "longform-usage",
      viewBox: "0 0 12.6 15.258",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#longform",
      toString: function () {
        return this.url;
      }
    }